// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
//import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
import {
  getAuth,
  signInWithCustomToken,
  onAuthStateChanged,
  signOut,
  sendSignInLinkToEmail,
  isSignInWithEmailLink,
  signInWithEmailLink,
} from 'firebase/auth';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyBAVQmWRCA8w2J4l56rGUWCXQn3-CvQ55g',
  authDomain: 'faceless-97bcf.firebaseapp.com',
  projectId: 'faceless-97bcf',
  storageBucket: 'faceless-97bcf.appspot.com',
  messagingSenderId: '611547386809',
  appId: '1:611547386809:web:3598ccb9b020b83a3c9c68',
  measurementId: 'G-D6HYR3R5HJ',
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const httpsCall = httpsCallable;
export const auth = getAuth(app);
export const signIn = signInWithCustomToken;
export const authChanged = onAuthStateChanged;
export const storage = getStorage(app);
export const f_sendSignInLinkToEmail = sendSignInLinkToEmail;
export const f_isSignInWithEmailLink = isSignInWithEmailLink;
export const f_signInWithEmailLink = signInWithEmailLink;

//const analytics = getAnalytics(app);

export default app;
